import React, { useContext } from 'react';
import MediaQuery from 'react-responsive';

// COMPONENTS
import HeaderCheckoutDesktop from './HeaderDesktop';
import HeaderCheckoutMobile from './HeaderMobile';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import { VertTokens } from '@vertem-core/vertice-ds';

// HEADER COMPONENT
const HeaderCheckout = () => {
  const { designTokens } = useContext(VertTokens);
  const { logotipo: Logotipo } = designTokens;

  /* Renders */
  return (
    <>
      {/* Mobile Version */}
      <MediaQuery maxWidth={1024}>
        <HeaderCheckoutMobile logo={Logotipo} />
      </MediaQuery>

      {/* Desktop Version */}
      <MediaQuery minWidth={1025}>
        <HeaderCheckoutDesktop logo={Logotipo} />
      </MediaQuery>
    </>
  );
};

export default HeaderCheckout;
